<template>
  <div class="container"></div>
</template>

<script>
import { lsModalService } from 'ls-vue-common';
import { GateLeftOpenModal } from '@/modals';

export default {
  name: 'GateLeftOpenView',
  created() {
    lsModalService.open({
      parent: this,
      component: GateLeftOpenModal,
      canCancel: [],
    });
  },
};
</script>

<style lang="scss" scoped></style>
